import { QuestionBase } from './question-base';

/**@author Lupita Llamas
 * Model for the radio questions
 */
export class RadioQuestion extends QuestionBase<string> {
  controlType = 'radio';
  options: {key: string, value: string}[] = [];

  constructor(options: {} = {}) {
    super(options);
    this.options = options['options'] || [];
  }
}



// WEBPACK FOOTER //
// ./src/app/models/question-radio.ts